import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row gx-1" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "row row gx-2" }
const _hoisted_6 = { class: "col-md-2" }
const _hoisted_7 = { class: "upload-container" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "text-center"
}
const _hoisted_10 = { class: "col-md-10" }
const _hoisted_11 = { class: "row gx-1" }
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = { class: "form-group mb-3 mb-sm-3 mb-md-3" }
const _hoisted_14 = { class: "col-md-3" }
const _hoisted_15 = { class: "form-group mb-3 mb-sm-3 mb-md-3" }
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "form-group mb-3 mb-sm-3 mb-md-3" }
const _hoisted_18 = { class: "col-md-4" }
const _hoisted_19 = {
  class: "form-group mb-sm-2 mb-md-2",
  ref: "dropdownRef"
}
const _hoisted_20 = {
  key: 0,
  class: "dropdown-menu show"
}
const _hoisted_21 = {
  class: "dropdown-item",
  href: "javascript:void(0);"
}
const _hoisted_22 = { class: "col-md-4" }
const _hoisted_23 = {
  class: "form-group mb-3 mb-sm-3 mb-md-3",
  ref: "dropdownRef1"
}
const _hoisted_24 = {
  key: 0,
  class: "dropdown-menu show"
}
const _hoisted_25 = {
  class: "dropdown-item",
  href: "javascript:void(0);"
}
const _hoisted_26 = { class: "col-md-4" }
const _hoisted_27 = {
  class: "form-group mb-3 mb-sm-3 mb-md-3",
  ref: "dropdownRef2"
}
const _hoisted_28 = {
  key: 0,
  class: "dropdown-menu show"
}
const _hoisted_29 = {
  class: "dropdown-item",
  href: "javascript:void(0);"
}
const _hoisted_30 = { class: "col-md-4" }
const _hoisted_31 = { class: "form-group mb-3 mb-sm-3 mb-md-3" }
const _hoisted_32 = { class: "col-md-4" }
const _hoisted_33 = { class: "form-group mb-3 mb-sm-3 mb-md-3" }
const _hoisted_34 = { class: "col-md-4" }
const _hoisted_35 = { class: "form-group mb-3 mb-sm-3 mb-md-3" }
const _hoisted_36 = { class: "col-md-4 mb-3" }
const _hoisted_37 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_38 = { class: "col-md-4 mb-4" }
const _hoisted_39 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_40 = { class: "col-md-8" }
const _hoisted_41 = { class: "form-group mb-3 mb-sm-3 mb-md-3" }
const _hoisted_42 = ["onUpdate:modelValue"]
const _hoisted_43 = { class: "col-md-4 mb-3" }
const _hoisted_44 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_45 = { class: "form-group mb-3 mb-sm-3 mb-md-3" }
const _hoisted_46 = { class: "d-block text-black fw-semibold mb-1" }
const _hoisted_47 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_48 = ["onUpdate:modelValue", "name", "type"]
const _hoisted_49 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_50 = { class: "col-md-12" }
const _hoisted_51 = { class: "d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[29] || (_cache[29] = _createElementVNode("div", { class: "card-header" }, [
      _createElementVNode("h3", { class: "text-black fw-semibold" }, "Modifier un produit")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "produitForm",
        onSubmit: _ctx.editProduit,
        "validation-schema": _ctx.produitSchema,
        "initial-values": _ctx.produitForm
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[13] || (_cache[13] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, " Image Produit ", -1)),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("input", {
                      type: "file",
                      ref: "fileInput",
                      onChange: _cache[0] || (_cache[0] = (event) => _ctx.onFilePrinChange(event)),
                      accept: "image/jpeg, image/png, image/jpg",
                      hidden: ""
                    }, null, 544),
                    _createElementVNode("div", {
                      class: "preview-card",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.triggerFileInput && _ctx.triggerFileInput(...args)))
                    }, [
                      (_ctx.imagePreview)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.imagePreview,
                            alt: "Image preview"
                          }, null, 8, _hoisted_8))
                        : (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[11] || (_cache[11] = [
                            _createElementVNode("div", null, [
                              _createElementVNode("i", { class: "icofont icofont-camera fs-1" })
                            ], -1),
                            _createTextVNode(" Cliquez pour ajouter l'image principal du produit ")
                          ]))),
                      (_ctx.imagePreview)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            class: "delete-btn",
                            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeImage && _ctx.removeImage(...args)), ["stop"]))
                          }, _cache[12] || (_cache[12] = [
                            _createElementVNode("i", { class: "icofont icofont-close" }, null, -1)
                          ])))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _cache[14] || (_cache[14] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, " Code du produit ", -1)),
                        _createVNode(_component_Field, {
                          type: "text",
                          modelValue: _ctx.codeProduit,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.codeProduit) = $event)),
                          name: "code",
                          class: "form-control shadow-none fs-md-15 text-black",
                          readonly: "true",
                          placeholder: "Ce code est généré"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "code",
                          class: "text-danger"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _cache[15] || (_cache[15] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, " Référence usine du produit ", -1)),
                        _createVNode(_component_Field, {
                          name: "refProd",
                          type: "text",
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Entrer la référence"
                        }),
                        _createVNode(_component_ErrorMessage, {
                          name: "refProd",
                          class: "text-danger"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _cache[16] || (_cache[16] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
                          _createTextVNode(" Famille du produit"),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "famille",
                          modelValue: _ctx.famille,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.famille) = $event))
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Multiselect, _mergeProps({
                              options: _ctx.familleOptions,
                              searchable: true,
                              "track-by": "label",
                              label: "label",
                              modelValue: field.value,
                              "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                            }, field, {
                              onSelect: ($event: any) => (_ctx.selectFamille(field.value)),
                              placeholder: "Sélectionner la famille"
                            }), null, 16, ["options", "modelValue", "onUpdate:modelValue", "onSelect"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "famille",
                          class: "text-danger"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _cache[17] || (_cache[17] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
                          _createTextVNode(" Nom du Produit"),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "nomProd",
                          type: "text",
                          modelValue: _ctx.prodName,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.prodName) = $event)),
                          onFocus: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showBox = true)),
                          class: "mb-2 form-control shadow-none fs-md-15 text-black",
                          placeholder: "Entrer le nom du produit"
                        }, null, 8, ["modelValue"]),
                        (_ctx.produitOptions.length > 0 && _ctx.showBox==true)
                          ? (_openBlock(), _createElementBlock("ul", _hoisted_20, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produitOptions, (produit, index) => {
                                return (_openBlock(), _createElementBlock("li", { key: index }, [
                                  _createElementVNode("a", _hoisted_21, _toDisplayString(produit.codeProduit) + " - " + _toDisplayString(produit.nomProd), 1)
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_ErrorMessage, {
                          name: "nomProd",
                          class: "text-danger"
                        })
                      ], 512)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _cache[18] || (_cache[18] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, " Nom Standar du produit ", -1)),
                        _createVNode(_component_Field, {
                          name: "nomStandar",
                          type: "text",
                          modelValue: _ctx.prodNameS,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.prodNameS) = $event)),
                          onFocus: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showBoxStan = true)),
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Entrer le nom"
                        }, null, 8, ["modelValue"]),
                        (_ctx.produitStanOptions.length > 0 && _ctx.showBoxStan==true)
                          ? (_openBlock(), _createElementBlock("ul", _hoisted_24, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produitStanOptions, (produit, index) => {
                                return (_openBlock(), _createElementBlock("li", { key: index }, [
                                  _createElementVNode("a", _hoisted_25, _toDisplayString(produit.codeProduit) + " - " + _toDisplayString(produit.nomProd), 1)
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_ErrorMessage, {
                          name: "nomStandar",
                          class: "text-danger"
                        })
                      ], 512)
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _cache[19] || (_cache[19] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, " Nom marché du produit ", -1)),
                        _createVNode(_component_Field, {
                          name: "nomMarche",
                          type: "text",
                          modelValue: _ctx.prodNameM,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.prodNameM) = $event)),
                          onFocus: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showBoxM = true)),
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Entrer le nom marché"
                        }, null, 8, ["modelValue"]),
                        (_ctx.produitMarOptions.length > 0 && _ctx.showBoxM==true)
                          ? (_openBlock(), _createElementBlock("ul", _hoisted_28, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produitMarOptions, (produit, index) => {
                                return (_openBlock(), _createElementBlock("li", { key: index }, [
                                  _createElementVNode("a", _hoisted_29, _toDisplayString(produit.codeProduit) + " - " + _toDisplayString(produit.nomProd), 1)
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_ErrorMessage, {
                          name: "nomMarche",
                          class: "text-danger"
                        })
                      ], 512)
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _cache[20] || (_cache[20] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
                          _createTextVNode(" Marque du produit"),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, { name: "marqProd" }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Multiselect, _mergeProps({
                              options: _ctx.marqueOptions,
                              searchable: true,
                              "track-by": "label",
                              label: "label",
                              modelValue: field.value,
                              "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                            }, field, { placeholder: "Choisir la marque" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ErrorMessage, {
                          name: "marqProd",
                          class: "text-danger"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _cache[21] || (_cache[21] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, " Unité de Stockage ", -1)),
                        _createVNode(_component_Field, { name: "uniteStock" }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Multiselect, _mergeProps({
                              options: _ctx.conditionnementOptions,
                              searchable: true,
                              "track-by": "label",
                              label: "label",
                              modelValue: field.value,
                              "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                            }, field, { placeholder: "Choisir l'unité de stockage" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ErrorMessage, {
                          name: "uniteStock",
                          class: "text-danger"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _cache[22] || (_cache[22] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, " Unité de gestion ", -1)),
                        _createVNode(_component_Field, { name: "uniteGestion" }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Multiselect, _mergeProps({
                              options: _ctx.conditionnementgOptions,
                              searchable: true,
                              "track-by": "label",
                              label: "label",
                              modelValue: field.value,
                              "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                            }, field, { placeholder: "Choisir l'unité de gestion" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ErrorMessage, {
                          name: "uniteGestion",
                          class: "text-danger"
                        })
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _cache[23] || (_cache[23] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
                  _createTextVNode(" Méthode de Suivi de stock "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "suiviStock",
                  type: "text"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      searchable: true,
                      options: ['CUMP', 'FIFO', 'LIFO', 'Par lot'],
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, { placeholder: "Sélectionner la méthode" }), null, 16, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "suiviStock",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _cache[24] || (_cache[24] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
                  _createTextVNode(" Pays de Fabrication "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "paysProduction",
                  type: "text"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      options: _ctx.pays,
                      searchable: true,
                      placeholder: "Sélectionner le pays de fabrication"
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "paysProduction",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _cache[25] || (_cache[25] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, " Description du produit ", -1)),
                _createVNode(_component_Field, {
                  name: "descProd",
                  as: "textarea",
                  cols: "15",
                  rows: "1",
                  placeholder: "Entrer la description",
                  class: "form-control shadow-none rounded-0 text-black"
                }, {
                  default: _withCtx(({ field }) => [
                    _withDirectives(_createElementVNode("textarea", {
                      class: "form-control shadow-none rounded-0 text-black",
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, null, 8, _hoisted_42), [
                      [_vModelText, field.value]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "descProd",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _cache[26] || (_cache[26] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, " Seuil d'approvisionnement ", -1)),
                _createVNode(_component_Field, {
                  name: "seuilAppro",
                  type: "number",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer le seuil d'approvisionnement"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "seuilAppro",
                  class: "text-danger"
                })
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chamsdescritifs, (champsLibre, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "col-md-3",
                key: index
              }, [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("label", _hoisted_46, [
                    _createTextVNode(_toDisplayString(champsLibre.libelleChamp) + " ", 1),
                    (champsLibre.estObligatoire == 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_47, "*"))
                      : _createCommentVNode("", true)
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass((_ctx.valideteRowProduit(champsLibre.valeur) && champsLibre.estObligatoire == 1) ? 'form-control shadow-none fs-md-15 text-black is-invalid ' : 'form-control shadow-none fs-md-15 text-black '),
                    "onUpdate:modelValue": ($event: any) => ((champsLibre.valeur) = $event),
                    name: champsLibre.nomChamp,
                    type: champsLibre.typeChamp
                  }, null, 10, _hoisted_48), [
                    [_vModelDynamic, champsLibre.valeur]
                  ]),
                  (_ctx.valideteRowProduit(champsLibre.valeur) && champsLibre.estObligatoire == 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(champsLibre.libelleChamp) + " est obligatoire. ", 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _cache[28] || (_cache[28] = _createElementVNode("button", {
                  class: "btn btn-success me-3",
                  type: "submit"
                }, " Modifier un produit ", -1)),
                _createVNode(_component_router_link, {
                  to: "/produits/liste-produits",
                  class: "btn btn-danger"
                }, {
                  default: _withCtx(() => _cache[27] || (_cache[27] = [
                    _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1),
                    _createElementVNode("span", { class: "position-relative" }, null, -1),
                    _createTextVNode("Annuler")
                  ])),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema", "initial-values"])
    ])
  ]))
}